<template>
  <DoubleColumnLayout>
    <template v-slot:default>
      <AppPage :publicId="$route.params.publicId" />
    </template>
    <template v-slot:right>
      <AppList :excludedAppId="$route.params.publicId" />
    </template>
  </DoubleColumnLayout>
</template>

<script>
// @ is an alias to /src
import AppList from "@/components/AppList.vue";
import AppPage from "@/components/AppPage.vue";
import DoubleColumnLayout from "@/components/DoubleColumnLayout.vue";

export default {
  name: "Application",
  components: {
    AppList,
    AppPage,
    DoubleColumnLayout,
  },
};
</script>
